import React, { Fragment } from "react";

import Backdrop from "../backdrop/backdrop";
import Modal from "../modal/modal";
import excludeProps from "../../utils/excludeProps";
// import LinkInputs from "./input/LinkInputs";
import MainInputs from "./input/MainInputs";
import INPUT_DATA from "../../data/pageInputs";
import { useState, useEffect, useRef } from "react";

function Form(props) {
  const FORM_DATA = INPUT_DATA[props.page.toUpperCase() + "_DATA"];

  const [state, setState] = useState({
    formData: FORM_DATA,
  });
  const prevProps = useRef(props);
  const prevState = useRef(state);

  useEffect(() => {
    console.log("render");
    if (
      props.editing &&
      prevProps.current.editing !== props.editing &&
      prevProps.current.currentItem !== props.currentItem
    ) {
      const item = excludeProps(props.currentItem, ["__v", "_id"]);

      const itemData = {};
      Object.entries(item).forEach(([key, innerObj]) => {
        itemData[key] = {
          ...prevState.current.formData.itemData[key],
          value: innerObj.value,
        };
      });
      setState({
        formData: {
          itemData: itemData,

          // itemLinks: [],
        },
      });
    }
  }, [props.editing, props.currentItem]);

  const postInputChangeHandler = (input, value, files) => {
    setState((prevState) => {
      let updatedData = state.formData.itemData;
      // let updatedLinks = state.formData.itemLinks;
      // const isLinks =
      //   (input.includes("link") && input.length > "link".length) ||
      //   (input.includes("name") && input.length > "name".length);
      // if (isLinks) {
      //   updatedLinks = prevState.formData.itemLinks.map((link) => {
      //     const { keyName, keyLink } = getObjKey(input);
      //     if (keyName || keyLink === input) {
      //       return {
      //         ...link,
      //         [input]: value,
      //       };
      //     } else {
      //       return link;
      //     }
      //   });
      // } else {
      // }
      updatedData = {
        ...prevState.formData.itemData,
        [input]: {
          ...prevState.formData.itemData[input],
          value: value,
        },
      };
      return {
        formData: {
          itemData: updatedData,
          // itemLinks: updatedLinks,
        },
      };
    });
  };

  // inputBlurHandler = (input) => {
  //   setState((prevState) => {
  //     return {
  //       postForm: {
  //         ...prevState.postForm,
  //         [input]: {
  //           ...prevState.postForm[input],
  //           touched: true,
  //         },
  //       },
  //     };
  //   });
  // };

  const cancelPostChangeHandler = () => {
    setState({
      formData: FORM_DATA,
      // formIsValid: false,
    });
    props.onCancelEdit();
  };

  const acceptPostChangeHandler = () => {
    // const post = {
    //   title: state.postForm.title.value,
    //   image: state.postForm.image.value,
    //   content: state.postForm.content.value,
    // };
    const item = {};
    console.log(new Date().getMinutes(), new Date().getSeconds());

    Object.entries(state.formData.itemData).forEach(([key, innerObj]) => {
      item[key] = innerObj.value;
    });
    console.log(new Date().getMinutes(), new Date().getSeconds());
    props.onFinishEdit(item);
    console.log(new Date().getMinutes(), new Date().getSeconds());

    setState({
      formData: FORM_DATA,
    });
  };

  // newInputHandler = (e) => {
  //   e.preventDefault();
  //   const Id = state.formData.itemLinks.length + 1;
  //   setState({
  //     formData: {
  //       itemData: state.formData.itemData,
  //       itemLinks: [
  //         ...state.formData.itemLinks,
  //         {
  //           ["name" + Id]: "",
  //           ["link" + Id]: "",
  //         },
  //       ],
  //     },
  //   });
  // };

  return props.editing ? (
    <Fragment>
      <Backdrop onClick={cancelPostChangeHandler} />
      <Modal
        title={props.currentItem ? "Save " + props.page : "Add " + props.page}
        // acceptEnabled={state.formIsValid}
        onCancelModal={cancelPostChangeHandler}
        onAcceptModal={acceptPostChangeHandler}
        button={props.currentItem ? "Save" : "Add"}
        // isLoading={props.loading}
      >
        <form>
          <MainInputs
            mainData={state.formData.itemData}
            changeHandler={postInputChangeHandler}
          />
          {/* <LinkInputs
              linksData={state.formData.itemLinks}
              changeHandler={postInputChangeHandler}
            /> */}
          {/* <button onClick={newInputHandler}>test</button> */}
        </form>
      </Modal>
    </Fragment>
  ) : null;
}

export default Form;
